import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useState, useContext, useEffect } from "react";
// import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { SweetAlertError } from '../../components/sweetAlert/swetAlert.jsx';

function ModalTrocarEmpresas() {
    const [showModalChave, setShowModalChave] = useState(true);
    // const {empresas, setNomeEmpresa} = useContext(AuthContext);
    const navigate = useNavigate();
    const empresas = JSON.parse(localStorage.getItem('empresas'));
    const [placeholder, setPlaceholder] = useState(null);

    function closeModal() {
        // if (selectedOption == null) {
        //     SweetAlertError({ texto: 'Falta selecionar a empresa.' });
        //     return;
        // }

        setShowModalChave(false);
        navigate("/dashboard");
        window.location.reload(true);
        // window.history.back();
    };

    // function ChangeEmpresa(e) {
    //     empresas.forEach(element => {
    //         if (element.idEntidade == e.target.value) {
    //             localStorage.setItem('idEmpresa', element.idEntidade);
    //             localStorage.setItem('nomeEmpresa', element.nome);
    //             localStorage.setItem('cnpjEmpresa', element.cnpj);
    //             localStorage.setItem('idGrupo', element.idGrupo);
    //             localStorage.setItem('cUF', element.cUF);
    //             localStorage.setItem('certSenha', element.certSenha);
    //             localStorage.setItem('nsuNFe', element.nsuNFe);
    //             localStorage.setItem('nsuCTe', element.nsuCTe);
    //             navigate("/dashboard");
    //             window.location.reload(true);
    //         }
    //     });
    // };

    const handleFunction1Change = (event) => {
       if (event == null) {
           return
       };
        for(var i = 0; i < empresas.length;i++){
            if(empresas[i].idEntidade == event.idEntidade){
                localStorage.setItem('idDefaultEmpresa',i);
            }
        };

        setShowModalChave(false);
        localStorage.setItem('idEmpresa', event.idEntidade);
        localStorage.setItem('nomeEmpresa', event.nome);
        localStorage.setItem('cnpjEmpresa', event.cnpj);
        localStorage.setItem('idGrupo', event.idGrupo);
        localStorage.setItem('cUF', event.cUF);
        localStorage.setItem('certSenha', event.certSenha);
        localStorage.setItem('nsuNFe', event.nsuNFe);
        localStorage.setItem('nsuCTe', event.nsuCTe);
        navigate("/dashboard");
        window.location.reload(true);
    }


    return <>
        <Modal
            show={showModalChave}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Empresas
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Select
                    placeholder="Selecione a empresa..."
                    onChange={handleFunction1Change}
                    options={empresas}
                    className="basic-single"
                    classNamePrefix="select"
                    defaultValue={empresas[localStorage.getItem('idDefaultEmpresa')]}
                    isDisabled={false}
                    isLoading={false}
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                />
                {/* <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Select className="form-select" onChange={ChangeEmpresa}>
                               <option>Selecione a empresa</option>
                                {
                                    
                                    empresas.map((item) => {
                                        return <option key={item.id} value={item.idEntidade}>{item.nome}</option>
                                    })
                                }
                            </Form.Select>

                    </Form.Group>
                </Form> */}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-outline-secondary float-end mr-4"
                    onClick={closeModal}>
                    Cancelar
                </button>
                {/* <Button ovariant="primary" onClick={ChangeEmpresa}>Selecionar Empresa</Button> */}
            </Modal.Footer>
        </Modal>
    </>
};
export default ModalTrocarEmpresas;
